import { FC } from 'react';

export interface ChevronUpDownIconProps {
  direction: 'up' | 'down';
  width?: number;
  height?: number;
  className?: string;
  stroke?: string;
}

/**
 * Стрелка-шеврон: вверх (свернуть) или вниз (развернуть).
 * Используется в панели участников для раскрытия/сворачивания списка ожидающих.
 */
export const ChevronUpDownIcon: FC<ChevronUpDownIconProps> = ({
  direction,
  width = 30,
  height = 30,
  className = '',
  stroke = 'white',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden
  >
    <path
      d={direction === 'up' ? 'M8 19L15 12L22 19' : 'M22 12L15 19L8 12'}
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
